module.exports = __webpack_public_path__ + "static/media/productos_ingredientes_cacahuate_horneado.c4e83ce3.jpg";